import React, { useState, useRef } from "react";
import { AdminTemplate, IPControlListingTable } from "../../components";
import { Stack, Tab, Tabs, useMediaQuery, useTheme } from '@mui/material';

export const IPControlPage = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [tabValue, setTabValue] = useState(0);
    const ipControlListingTableRef = useRef<any>();

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    const handleAddButton = () => {
        if (ipControlListingTableRef.current) {
            ipControlListingTableRef.current.openModal();
        }
    };

    return (
        <AdminTemplate
            headerProps={{
                headerTitle: 'IP Kontrol Yönetimi',
                hideDownloadButton: true,
                hideSearchBar: true,
                onClickAddButton: handleAddButton,
                hideAddButton: false,
            }}
        >
            <Stack flex={1} p={2}>
                <Tabs centered value={tabValue} onChange={handleTabChange} sx={{
                    '.MuiTabs-flexContainer': {
                        flexDirection: isMobile ? 'column' : 'row',
                    },
                    '.MuiTabs-indicator': {
                        display: isMobile ? 'none' : 'flex',
                    },
                    '.Mui-selected': {
                        position: 'relative',
                        '&::after': isMobile ? {
                            content: '""',
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            borderBottom: '2px solid',
                            borderColor: 'primary.main',
                        } : {}
                    }
                }}>
                    <Tab label="Engellenen IP’ler" />
                    <Tab label="İzin Verilen IP’ler" />
                </Tabs>

                {tabValue === 0 && <IPControlListingTable ref={ipControlListingTableRef} type={1} key="blacklist" />}
                {tabValue === 1 && <IPControlListingTable ref={ipControlListingTableRef} type={2} key="whitelist" />}
            </Stack>
        </AdminTemplate>
    );
};
